import { Injectable } from '@angular/core';
import {BaseProviderService} from "../../../services/base-provider.service";
import {
  IBibliotecaFormularioService,
  IBibliotecaTabelaService
} from "../../../bibliotecaPjus/services/contrato.services";
import {Proposta} from "../../../aplicacao/models/proposta.model";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {FiltroPropostaModel} from "../../../aplicacao/models/filtro-proposta.model";
import {FiltroPaginacao, ListaPaginada} from "../../../bibliotecaPjus/models/comum.models";

@Injectable({
  providedIn: 'root'
})
export class ParceiroCompletarDadosService extends BaseProviderService implements IBibliotecaTabelaService<Proposta, any, any>, IBibliotecaFormularioService<Proposta> {
  protected module = 'DadosComplementares';

  model;

  constructor(protected http: HttpClient) {
    super(http);
  }

  criar(): Proposta {
    return new Proposta();
  }

  getDataCadastro(id: string): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v1, this.module, ['ObterDataFinalizado' + '?parceiroId=' + id]))
      .pipe(map(x => x));
  }

  get(id: string): Observable<Proposta> {
    return this.http.get<Proposta>(this.getUrl(this.v1, this.module, [id]))
      .pipe(map(x => new Proposta(x)));
  }

  getCabecalho(id: string): Observable<any> {
    return this.http.get<any>(this.getUrl(this.v1, this.module, ['Cabecalho', id]))
      .pipe(map(x => x));
  }

  list(pagina: number, qtd: number, status, objFiltro, subStatus = null): Observable<any> {
    const filtro = new FiltroPropostaModel(objFiltro);
    return this.http.get(this.getUrl(this.v1, this.module, ['Recuperar', 'Parceiro', 'Pagina', pagina, 'Quantidade', qtd + '?StatusProposta='+ status +
    (filtro.valorMin ? '&ValorMinimo=' + filtro.valorMin : '') +
    (filtro.valorMax ? '&ValorMaximo=' + filtro.valorMax : '') +
    (filtro.periodo ? '&DataInicio=' + filtro.periodo.start : '') +
    (filtro.periodo ? '&DataFim=' + filtro.periodo.end : '') +
    (filtro.documento ? '&DocumentoCedente=' + filtro.documento : '') +
    (subStatus ? '&' + subStatus : '')
    ])).pipe(map(d => new ListaPaginada<Proposta>(Proposta, d)));
  }

  filter(filter: FiltroPaginacao<any, any>): Observable<ListaPaginada<Proposta>> {
    return this.http.post<ListaPaginada<Proposta>>(this.getUrl(this.v1, this.module, ['filter']), filter)
      .pipe(map(d => new ListaPaginada<Proposta>(Proposta, d)));
  }

  atualizar(model: Proposta): Observable<Proposta> {
    return this.http.patch<Proposta>(this.getUrl(this.v1, this.module, [model.propostaId]), model)
      .pipe(map(x => new Proposta(x)));
  }

  salvar(model: Proposta): Observable<Proposta> {
    delete model.propostaId;
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module), model).pipe(map(x => new Proposta(x)));
  }

  aceitarOferta(model): Observable<Proposta> {
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module, ['Aceite', 'Parceiro']), model)
      .pipe(map(x => x));
  }

  deletar(id: number): Observable<Proposta> {
    return this.http.delete<Proposta>(this.getUrl(this.v1, this.module, [id]))
      .pipe(map(x => new Proposta(x)));
  }

  cancelarProposta(model): Observable<Proposta> {
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module, ['Parceiro', 'ReprovarProposta']), model)
      .pipe(map(x => x));
  }

  novoCalculo(model): Observable<Proposta> {
    return this.http.post<Proposta>(this.getUrl(this.v1, this.module, ['NovoCalculo', 'Proposta', model.propostaId]), model)
      .pipe(map(x => x));
  }

  contraProposta(model: any): Observable<any> {
    return this.http.post(this.getUrl(this.v1, this.module, ['Parceiro', 'GerarContraProposta']), model)
      .pipe(map(x => x));
  }

  enviar(parceiroId): Observable<any> {
    return this.http.post(this.getUrl(this.v1, this.module, ['Finalizar', '?parceiroId=' + parceiroId]), {})
      .pipe(map(x => x));
  }

  continuarProcesso(parceiroId): Observable<any> {
    return this.http.post(this.getUrl(this.v1, this.module, ['RenovarEObterDataFinalizado?parceiroId=' + parceiroId]), null)
      .pipe(map(x => x));
  }

}
